module.exports = __webpack_public_path__ + "static/utbwi-8bfaaed8ac0a829e98baa97391adf2cb.png";